import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import MainLayout from './components/layout/MainLayout';
import Home from './pages/Home/Home';
import SearchPage from './pages/Search/SearchPage';
import MediaDetailPage from './pages/MediaDetail/MediaDetailPage';
import MediaSimilarPage from './pages/MediaSimilarPage/MediaSimilarPage';
import NotFound from './pages/NotFound/NotFound';
import ExplorePage from './pages/Explore/ExplorePage';
import CategoriesHub from './pages/Categories/CategoriesHub';
import CategoriesBrowse from './pages/Categories/CategoriesBrowse';
import SimilarBrowse from './pages/Similar/SimilarBrowse';
import RedirectToCategories from './pages/Categories/RedirectToCategories';
import AboutPage from './pages/About/AboutPage';
import ContactPage from './pages/Contact/ContactPage';
import PrivacyPage from './pages/Legal/PrivacyPage';
import TermsPage from './pages/Legal/TermsPage';
import FaqPage from './pages/Faq/FaqPage';
import RegionHome from './pages/RegionHome';
import LoginPage from './pages/Auth/Login';
import RegisterPage from './pages/Auth/Register';
import ForgotPasswordPage from './pages/Auth/ForgotPassword';
import ResetPasswordPage from './pages/Auth/ResetPassword';
import DashboardPage from './pages/Dashboard/DashboardPage';
import TopMatchesPage from './pages/Top/TopMatchesPage';
import UserProfilePage from './pages/UserProfile/UserProfilePage';

const Page = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background};
`;

const mediaDetail = (
  <>
    <Route path="movies/:idSlug" element={<MediaDetailPage category="movie" />} />
    <Route path="tv/:idSlug" element={<MediaDetailPage category="tv" />} />
    <Route path="anime/movies/:idSlug" element={<MediaDetailPage category="anime_movie" />} />
    <Route path="anime/tv/:idSlug" element={<MediaDetailPage category="anime_tv" />} />
    <Route path="movies/:idSlug/similar" element={<MediaSimilarPage category="movie" />} />
    <Route path="tv/:idSlug/similar" element={<MediaSimilarPage category="tv" />} />
    <Route path="anime/movies/:idSlug/similar" element={<MediaSimilarPage category="anime_movie" />} />
    <Route path="anime/tv/:idSlug/similar" element={<MediaSimilarPage category="anime_tv" />} />
  </>
);

const staticPages = (
  <>
    <Route path="category" element={<RedirectToCategories />} />
    <Route path="categories" element={<CategoriesHub />} />
    <Route path="categories/:type" element={<CategoriesBrowse />} />
    <Route path="similar/:type" element={<SimilarBrowse />} />
    <Route path="login" element={<LoginPage />} />
    <Route path="register" element={<RegisterPage />} />
    <Route path="forgot-password" element={<ForgotPasswordPage />} />
    <Route path="reset-password" element={<ResetPasswordPage />} />
    <Route path="dashboard" element={<DashboardPage />} />
    <Route path="profile/:username" element={<UserProfilePage />} />
    <Route path="top/movies" element={<TopMatchesPage type="movies" />} />
    <Route path="top/tv" element={<TopMatchesPage type="tv" />} />
    <Route path="top/anime" element={<TopMatchesPage type="anime" />} />
    <Route path="top/anime-movies" element={<TopMatchesPage type="anime-movies" />} />
    <Route path="top/anime-tv" element={<TopMatchesPage type="anime-tv" />} />
    <Route path="about" element={<AboutPage />} />
    <Route path="contact" element={<ContactPage />} />
    <Route path="privacy" element={<PrivacyPage />} />
    <Route path="terms" element={<TermsPage />} />
    <Route path="faq" element={<FaqPage />} />
  </>
);

const regionStatic = (
  <>
    <Route path=":region/category" element={<RedirectToCategories />} />
    <Route path=":region/categories" element={<CategoriesHub />} />
    <Route path=":region/categories/:type" element={<CategoriesBrowse />} />
    <Route path=":region/similar/:type" element={<SimilarBrowse />} />
    <Route path=":region/login" element={<LoginPage />} />
    <Route path=":region/register" element={<RegisterPage />} />
    <Route path=":region/forgot-password" element={<ForgotPasswordPage />} />
    <Route path=":region/reset-password" element={<ResetPasswordPage />} />
    <Route path=":region/dashboard" element={<DashboardPage />} />
    <Route path=":region/profile/:username" element={<UserProfilePage />} />
    <Route path=":region/top/movies" element={<TopMatchesPage type="movies" />} />
    <Route path=":region/top/tv" element={<TopMatchesPage type="tv" />} />
    <Route path=":region/top/anime" element={<TopMatchesPage type="anime" />} />
    <Route path=":region/top/anime-movies" element={<TopMatchesPage type="anime-movies" />} />
    <Route path=":region/top/anime-tv" element={<TopMatchesPage type="anime-tv" />} />
    <Route path=":region/about" element={<AboutPage />} />
    <Route path=":region/contact" element={<ContactPage />} />
    <Route path=":region/privacy" element={<PrivacyPage />} />
    <Route path=":region/terms" element={<TermsPage />} />
    <Route path=":region/faq" element={<FaqPage />} />
  </>
);

const regionMedia = (
  <>
    <Route path=":region/movies/:idSlug" element={<MediaDetailPage category="movie" />} />
    <Route path=":region/tv/:idSlug" element={<MediaDetailPage category="tv" />} />
    <Route path=":region/anime/movies/:idSlug" element={<MediaDetailPage category="anime_movie" />} />
    <Route path=":region/anime/tv/:idSlug" element={<MediaDetailPage category="anime_tv" />} />
    <Route path=":region/movies/:idSlug/similar" element={<MediaSimilarPage category="movie" />} />
    <Route path=":region/tv/:idSlug/similar" element={<MediaSimilarPage category="tv" />} />
    <Route path=":region/anime/movies/:idSlug/similar" element={<MediaSimilarPage category="anime_movie" />} />
    <Route path=":region/anime/tv/:idSlug/similar" element={<MediaSimilarPage category="anime_tv" />} />
  </>
);

export default function App() {
  return (
    <BrowserRouter>
      <Page>
        <Routes>
          <Route element={<MainLayout />}>
            <Route index element={<Home />} />
            <Route path="search" element={<SearchPage />} />
            <Route path="explore/:type" element={<ExplorePage />} />
            {staticPages}
            {mediaDetail}

            <Route path=":region/search" element={<SearchPage />} />
            <Route path=":region/explore/:type" element={<ExplorePage />} />
            {regionStatic}
            {regionMedia}

            <Route path=":region" element={<RegionHome />} />

            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Page>
    </BrowserRouter>
  );
}
